import React from 'react';
import {Pagination} from "antd";
import RenderIf from "@/components/render-if";
import toFaNumber from "@/lib/utils/number";

function PaginationRaw({data, setPage, setPerPage}) {

    return (
        <>
            <RenderIf condition={!!data?.meta?.total}>
                <div className={`flex justify-end my-2 items-center`}>

                    <Pagination current={data?.meta?.current_page} total={data?.meta?.total}
                                pageSize={data?.meta?.per_page}
                                showSizeChanger={true}
                                showTotal={(total, range) =>
                                    `${toFaNumber(range[0])}-${toFaNumber(range[1])} از ${toFaNumber(total)}   مورد `
                                }

                                onChange={
                                    (page, perPage) => {
                                        setPage(page);
                                        setPerPage(perPage)
                                    }
                                }/>
                </div>
            </RenderIf>
        </>
    );
}

export default PaginationRaw;